// src/pages/BranchLedger/components/BranchLedgerFilters.js
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../BranchLedgerSlice";
import { fetchBranchLedger, fetchBranches } from "../BranchLedgerThunk";
import RecordDateFilter from "../../../../components/filters/RecordDateFilter";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";

const { Option } = Select;

const BranchLedgerFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters, branches, branchLoading } = useSelector(
    (state) => state.branchLedger
  );

  useDefaultDateRange(setFilters, filters, "today");

  useEffect(() => {
    dispatch(fetchBranches());
  }, [dispatch]);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    if (!filters.branchId) {
      messageApi.warning("Select Branch");
      return;
    }

    dispatch(fetchBranchLedger({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch records ❌");
      }
    });
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} sm={12} md={12} lg={6}>
          <label>Select Branch</label>
          <Select
            loading={branchLoading}
            value={filters.branchId}
            onChange={(val) => handleFilterChange("branchId", val)}
            style={{ width: "100%" }}
            placeholder="Select Branch"
            showSearch
            optionFilterProp="children"
          >
            {branches.map((b) => (
              <Option key={b.id} value={b.id}>
                {b.name}
              </Option>
            ))}
          </Select>
        </Col>

        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
          handleFilterChange("fromDate", fromDate);
          handleFilterChange("toDate", toDate);
          }}
        />

        <Col
          xs={24}
          sm={12}
          md={12}
          lg={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            block
            style={{height:35.19}}
            data-testid="report-btn"
          >
            Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default BranchLedgerFilters;
